<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('configModel_title') }}
        </h3>

        <div class="search" v-auth="['auth_dict_group']">
          <router-link to="/manage/system/config-model/group">
            <a-button type="dashed" size="small">
              {{ $t('configModel_group_title') }}<a-icon type="double-right" />
            </a-button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main config-main" v-if="groupList && groupList.length">
      <div class="config-side">
        <!-- <h4>
          <a-icon type="unordered-list" />
          {{ $t('configModel_group_list') }}
        </h4> -->
        <ul>
          <li
            v-for="item in groupList"
            :key="item.groupId"
            :class="currentGroup.groupId === item.groupId ? 'active' : ''"
            @click="changeGroup(item)"
          >
            {{ item.groupName }}
          </li>
        </ul>
      </div>
      <div class="config-content">
        <Loading :show="loading" v-if="loading" />
        <div v-else>
          <div class="config-content-title">
            <a-button
              type="danger"
              size="small"
              @click="deleteBatch()"
              v-if="itemList && itemList.length"
              icon="delete"
              v-auth="['auth_dict_delete_batch']"
              :disabled="!hasSelected"
            >
              {{ $t('com_btn_delete_batch') }}
            </a-button>

            <a-button
              type="primary"
              size="small"
              @click="showUpdate()"
              icon="plus"
              v-auth="['auth_dict_add']"
            >
              {{ $t('configModel_btn_add_item') }}
            </a-button>
          </div>

          <div class="g-table">
            <a-table
              :columns="columns"
              :data-source="itemList"
              :pagination="false"
              :rowKey="(_text, index) => _text.dictId"
              bordered
              :row-selection="
                authList.includes('auth_dict_delete_batch') || isSuperAdmin
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }
                  : null
              "
              size="small"
            >
              <!-- 名称 -->
              <template slot="Name" slot-scope="text, record">
                <div
                  @click="showUpdate(record)"
                  style="text-decoration: underline;cursor: pointer;"
                >
                  {{ text }}
                </div>
              </template>

              <!-- 类型 -->
              <template slot="dataType" slot-scope="text">
                {{ itemTypes[text] ? itemTypes[text].name : '--' }}
              </template>

              <!-- 范围 -->
              <template slot="dataRange" slot-scope="text, record">
                <div v-if="record.dataType === 4">
                  <p v-for="item in text.split('\n')" :key="item" style="margin:0;">
                    {{ item }}
                  </p>
                </div>
                <span v-else>{{ text }}</span>
              </template>

              <!-- 时间 -->
              <template slot="createTime" slot-scope="text">
                {{ text | formatDate }}
              </template>

              <!-- 操作 -->
              <template slot="Action" slot-scope="text, record">
                <a-button
                  type="primary"
                  size="small"
                  @click="showUpdate(record)"
                  icon="edit"
                  v-auth="['auth_dict_edit']"
                >
                  {{ $t('com_btn_edit') }}
                </a-button>

                <a-button
                  type="special"
                  size="small"
                  @click="showUpdate(record, true)"
                  icon="fork"
                  v-auth="['auth_dict_add']"
                >
                  {{ $t('com_btn_fork') }}
                </a-button>

                <a-button
                  type="danger"
                  size="small"
                  @click="deleteBatch(record.dictId)"
                  icon="delete"
                  v-auth="['auth_dict_delete_batch']"
                >
                  {{ $t('com_btn_delete') }}
                </a-button>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <Empty v-else />

    <!-- 添加/编辑 -->
    <Update
      ref="update"
      :groupList="groupList"
      :callback="getConfigGroupItemList"
      v-if="currentGroup"
    />
  </div>
</template>
<script>
import * as API from '@/api/system/config';
import * as APIGroup from '@/api/system/config';
import Update from './conponents/update.vue';
import itemTypes from '@/libs/itemTypes';
import { mapGetters } from 'vuex';
import { dragTableToScroll } from '@/libs/utils';

export default {
  components: {
    Update,
  },
  data() {
    return {
      form: {},
      rules: {},
      groupList: [],
      expandedKeys: [],
      defaultSelectedKeys: [],

      // 当前Group
      currentGroup: null,

      // 当前菜单信息
      currentMenuInfo: null,
      loading: false,

      // infterface表头
      itemTypes: { ...itemTypes.object },
      columns: [
        {
          title: '#',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'dataType',
          scopedSlots: { customRender: 'dataType' },
        },
        {
          title: this.$t('configModel_table_range'),
          dataIndex: 'dataRange',
          scopedSlots: { customRender: 'dataRange' },
        },

        {
          title: this.$t('configModel_table_unit'),
          dataIndex: 'dataUnit',
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      itemList: [],

      selectedRowKeys: [],
      horizontalScroll: null,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },

  created() {
    // 权限操作
    if (
      this.authList.includes('auth_dict_edit') ||
      this.authList.includes('auth_dict_delete_batch') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }

    this.getGroupList();
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 获取菜单列表
    getGroupList() {
      APIGroup.ConfigGroupList()
        .then(res => {
          this.groupList = res.data || [];

          // 跳转第1个
          if (this.groupList && this.groupList.length && !this.currentGroupId) {
            this.currentGroup = this.groupList[0];
          }

          this.getConfigGroupItemList();
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
        });
    },

    // 获取当前group item list
    getConfigGroupItemList() {
      if (this.currentGroup) {
        this.loading = true;
        APIGroup.ConfigGroupItemList({ groupId: this.currentGroup.groupId })
          .then(res => {
            if (res.code === 0) {
              this.itemList = res.data || [];
            }
          })
          .finally(() => {
            this.loading = false;

            // 表格横向滚动注册
            this.$nextTick(() => {
              this.horizontalScrollDestory();
              this.horizontalScroll = dragTableToScroll(
                document.querySelector('.ant-table-body'),
                document.querySelector('.ant-table-tbody table')
              );
            });
          });
      }
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    onSelect(keys, event) {
      const value = keys[0] || event.value;
      this.defaultSelectedKeys = [String(value)];
      this.getMenuInfo(Number(value));
    },

    // batch delete
    deleteBatch(id) {
      let ids = [];
      if (typeof id !== 'undefined') {
        ids.push(id);
      } else {
        ids = this.selectedRowKeys;

        if (!(ids && ids.length)) {
          this.$message.error(this.$t('com_msg_select_item_first'));
          return;
        }
      }

      const h = this.$createElement;
      this.$confirm({
        title:
          ids.length > 1
            ? this.$t('configmModel_confirm_delete_some_title')
            : this.$t('configmModel_confirm_delete_title'),
        content: h('div', {}, [h('p', this.$t('configmModel_confirm_delete_content', { ids }))]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.ConfigItemBatchDelete({ dictIds: ids.join(',') })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 清空选择项
                this.selectedRowKeys = [];

                // 重新获取列表
                this.getConfigGroupItemList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 切换group
    changeGroup(record) {
      this.currentGroup = record;
      this.getConfigGroupItemList();
    },

    // 编辑/添加
    showUpdate(record, fork) {
      this.$refs.update.show(this.currentGroup, record, fork);
    },
  },
};
</script>
<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
}
.g-content {
  padding: 0;
  .config-main {
    display: flex;
    height: 100%;
    flex-direction: row !important;
    overflow: hidden !important;
    .config-side {
      width: 240px;
      box-sizing: border-box;
      border-right: #eee solid 1px;
      overflow-y: auto;
      h4 {
        background: #eee;
        font-weight: normal;
        margin-top: 1px;
        padding: 5px 20px;
        font-size: 12px;
        color: #999;
        text-align: center;
      }

      ul {
        padding: 10px 20px;
        li {
          padding: 7px;
          margin-bottom: 5px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          &.active {
            color: #fff;
            background: #1838d9;
            border-radius: 5px;
          }

          &:not(.active):hover {
            color: #1838d9;
            cursor: pointer;
            background: #f5f5f5;
            border-radius: 5px;
          }
        }
      }
    }

    .config-content {
      flex: 1;
      padding: 15px 20px;
      overflow-x: auto;

      .config-content-title {
        display: flex;
        align-items: center;
        span {
          font-size: 18px;
          margin-right: 20px;
          color: #000;
        }
        button {
          margin-right: 15px;
        }

        padding-bottom: 20px;
      }
    }
  }
}
</style>
